import {
    postRequestWithFormDataForLayer,
    postRequestWithFormData,
} from '../utils/HelperFunctions.js';

export const createNewBusinessInformation = async (data, paramsObject = {}) => {
    let businessData = {
        external_id: data['BusinessInformation[account_id]'],
        legal_name: data['BusinessInformation[legal_name]'],
        tin: data['BusinessInformation[tax_id]'],
        us_state: data['BusinessInformation[state]'],
        entity_type: data['BusinessInformation[company_type]'],
    };
    const res = await postRequestWithFormDataForLayer(businessData, 'on-boarding', paramsObject);
    data['BusinessInformation[layer_business_id]'] = res.data.id;

    await postRequestWithFormData(data, 'business/create', paramsObject);
    return res.BusinessInformation;
};
